import React, { createContext, useContext, useEffect, useRef, useState } from 'react';
import { readCountry } from '../functions';
import { SelectedCountryContext } from './SelectedCountryContext';

export const CountryDataContext = createContext({
  country: null,
  loading: false,
  error: null,
});

export const CountryDataProvider = ({ children }) => {
  const { selectedCountryId } = useContext(SelectedCountryContext);
  const [country, setCountry] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const lastIdRef = useRef(null);
  const cacheRef = useRef(new Map());

  useEffect(() => {
    const idKey = String(selectedCountryId || 'default');
    if (lastIdRef.current === idKey && country) {
      return; // already current
    }
    // serve from cache when available
    if (cacheRef.current.has(idKey)) {
      setCountry(cacheRef.current.get(idKey));
      lastIdRef.current = idKey;
      return;
    }
    let mounted = true;
    (async () => {
      setLoading(true);
      setError(null);
      try {
        const data = await readCountry(selectedCountryId || undefined);
        if (!mounted) return;
        cacheRef.current.set(idKey, data);
        lastIdRef.current = idKey;
        setCountry(data);
      } catch (err) {
        if (mounted) setError(err);
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => { mounted = false };
  }, [selectedCountryId]);

  return (
    <CountryDataContext.Provider value={{ country, loading, error }}>
      {children}
    </CountryDataContext.Provider>
  );
};
